// base API path for api requests
export const BASE_URL = `/txt-portal/scla`;